export type { StandardInputProps } from "./StandardInput";
import StandardInput from "./StandardInput";
export default StandardInput;
